var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LeadsList',{attrs:{"leads":_vm.leads,"title":"Due Leads"}})
}
var staticRenderFns = []

export { render, staticRenderFns }